import { Box, Grid, Paper, Typography } from "@mui/material";
import StaffingImg from "../..//images/staffing-pc.jpg";

import Icon1 from "../../images/Icon-1.png";
import Icon2 from "../../images/Icon-2.png";
import Icon3 from "../../images/Icon-3.png";
import Icon4 from "../../images/Icon-4.png";
import Icon5 from "../../images/Icon-5.png";
import Icon6 from "../../images/Icon-6.png";
import Icon7 from "../../images/Icon-7.png";
import Icon8 from "../../images/Icon-8.png";

import Icon9 from "../../images/Icon-9.png";
import Icon10 from "../../images/Icon-10.png";
import Icon11 from "../../images/Icon-11.png";
import Icon12 from "../../images/Icon-12.png";
import Icon13 from "../../images/Icon-13.png";
import Icon14 from "../../images/Icon-14.png";

import icon15 from "../../images/icon-15.png";
import icon16 from "../../images/icon-16.png";
import icon17 from "../../images/icon-17.png";
import icon18 from "../../images/icon-18.png";
import icon19 from "../../images/icon-19.png";

import Icon20 from "../../images/Icon20.png";
import Icon21 from "../../images/icon21.png";
import Icon22 from "../../images/icon22.png";
import Icon23 from "../../images/icon23.png";
import Icon24 from "../../images/icon24.png";

import ContractImg from "../../images/contract-bg.jpg";

const StaffingService = () => {
  const steps = [
    {
      label: "Job Analysis & Planning",
      icon: Icon1,
    },
    {
      label: "HR software", //Approach to
      icon: Icon2,
    },
    {
      label: "Candidate Sourcing",
      icon: Icon3,
    },
    {
      label: "Candidate Evaluation",
      icon: Icon4,
    },
    {
      label: "Coordination Interviews",
      icon: Icon5,
    },
    {
      label: "Background Verification",
      icon: Icon6,
    },
    {
      label: "Offer & joining",
      icon: Icon7,
    },
    {
      label: "On-boarding & Integration",
      icon: Icon8,
    },
  ];

  const contractBenefits = [
    {
      label: "Candidates for all business sector",
      icon: Icon9,
    },
    {
      label: "Access skilled resources rapidly",
      icon: Icon10,
    },
    {
      label: "Stay agile and flexible",
      icon: Icon11,
    },
    {
      label: "Easily respond to fluctuating work loads",
      icon: Icon12,
    },
    {
      label: "Quickly fill skill gaps",
      icon: Icon13,
    },
    {
      label: "Keep resource cost low",
      icon: Icon14,
    },
  ];

  const contractSteps = [
    {
      label: "Flexibility",
      icon: icon15,
    },
    {
      label: "Minimize payroll accounting and costs",
      icon: icon16,
    },
    {
      label: "Reduce staffing and recruiting cost",
      icon: icon17,
    },
    {
      label: "Temporary to permanent possibility",
      icon: icon18,
    },
    {
      label: "Staff according to the need of the business",
      icon: icon19,
    },
  ];
  const permanentSteps = [
    {
      label: "Job security",
      icon: Icon20,
    },
    {
      label: "Working on salary",
      icon: Icon21,
    },
    {
      label: "Screening resumes",
      icon: Icon22,
    },
    {
      label: "Long-term prospects",
      icon: Icon23,
    },
    {
      label: "Verifying references",
      icon: Icon24,
    },
  ];
  return (
    <Box
      sx={{
        position: "relative",
        mb: 8,
        backgroundImage: `url(${StaffingImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        py: { xs: 6, md: 10 },
      }}
    >
      {/* Slight white overlay to soften the background */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(255,255,255,0.6)",
        }}
      />

      {/* sgat */}
      <Box
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
          // maxWidth: 1200,
          mx: "auto",
          // px: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={0} alignItems="stretch">
          {/* left: benefits icons */}
          <Grid item xs={12} md={7}>
            <Box sx={{ bgcolor: "#f5f7fa", p: { xs: 4, md: 6 } }}>
              <Grid container spacing={3}>
                {steps.map((item, index) => (
                  <Grid item xs={6} sm={3} key={item.label}>
                    <Box sx={{ textAlign: "center" }}>
                      <Box
                        component="img"
                        src={item.icon}
                        alt={item.label}
                        sx={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          mb: 2,
                          mx: "auto",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1e3c72",
                          lineHeight: 1.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Our Process
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                For over ten years, the AlphaForce team has been providing high
                end data science, application development and cloud science
                staffing solutions to Fortune 1000 and mid sized companies in
                the US, Canada and India.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                Our staffing services help our clients to execute large-scale
                technology initiatives. We have always proven ourselves in
                delivering eminent, qualified, and reliable IT professionals. We
                are the providers of contract IT staffing for several Fortune
                1000 clients and have been awarded as the &quot;360 Ranked Best
                Company&quot; by Entrepreneur.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* <Box
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
  
          mx: "auto",

        }}
      >
        <Grid container spacing={4} alignItems="stretch">
        
          <Grid item xs={12} md={7}>
            <Grid container spacing={3}>
              {steps.map((step, index) => (
                <Grid item xs={6} sm={4} md={3} key={step.label}>
                  <Paper
                    elevation={0}
                    sx={{
                      position: "relative",
                      borderRadius: 3,
                      px: 3,
                      py: 4,
                      minHeight: 200,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "#ffffff",
                      border: "1px solid #e8eef7",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                      "&:hover": {
                        boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                        transform: "translateY(-4px)",
                      },
                    }}
                  >
                  
                    <Box
                      component="img"
                      src={step.icon}
                      alt={step.label}
                      sx={{
                        width: 70,
                        height: 70,
                        objectFit: "contain",
                        mb: 2,
                        zIndex: 1,
                      }}
                    />

            
                    <Typography
                      align="center"
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#1e3c72",
                        zIndex: 1,
                        lineHeight: 1.4,
                      }}
                    >
                      {step.label}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>

 
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Our Process
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600
                }}
              >
                For over ten years, the AlphaForce team has been providing high
                end data science, application development and cloud science
                staffing solutions to Fortune 1000 and mid sized companies in
                the US, Canada and India.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600
                }}
              >
                Our staffing services help our clients to execute large-scale
                technology initiatives. We have always proven ourselves in
                delivering eminent, qualified, and reliable IT professionals. We
                are the providers of contract IT staffing for several Fortune
                1000 clients and have been awarded as the &quot;360 Ranked Best
                Company&quot; by Entrepreneur.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box> */}

      {/* Contract Staffing section */}
      <Box
        maxWidth="lg"
        sx={{
          mt: 8,
          position: "relative",
          zIndex: 1,
          // maxWidth: 1200,
          mx: "auto",
          // px: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={0} alignItems="stretch">
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Contract Staffing
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                We have a team of certified recruiters and managers partnered
                with the customers to provide them with qualified and reliable
                IT consultants in various locations around the world. Our
                capability and experience as among the leading IT staffing
                companies are praiseworthy because of our in-depth knowledge of
                various industry-specific skill areas in data science,
                application development and cloud science. We provide the
                expertise that every technology leader needs to ensure swift
                system implementation, enhancement, and production support
                initiatives for his venture.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                Our capabilities in providing high-quality, on-demand IT
                staffing in niche skill areas across the wide spectrum of
                information technology has resulted in hundreds of successful
                projects in several key areas including application development,
                software testing, project management, system engineering,
                business intelligence, enterprise architecture, cyber security,
                etc.
              </Typography>
            </Box>
          </Grid>

          {/* Right: benefits icons */}
          <Grid item xs={12} md={5}>
            <Box sx={{ bgcolor: "#f5f7fa", p: { xs: 4, md: 6 } }}>
              <Grid container spacing={3}>
                {contractBenefits.map((item, index) => (
                  <Grid item xs={6} sm={4} key={item.label}>
                    <Box sx={{ textAlign: "center" }}>
                      <Box
                        component="img"
                        src={item.icon}
                        alt={item.label}
                        sx={{
                          width: 70,
                          height: 70,
                          objectFit: "contain",
                          mb: 2,
                          mx: "auto",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1e3c72",
                          lineHeight: 1.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Contract Staffing section */}
      <Box
        maxWidth="lg"
        sx={{
          mt: 8,
          position: "relative",
          zIndex: 1,
          // maxWidth: 1200,
          mx: "auto",
          // px: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={0} alignItems="stretch">
          {/* left: benefits icons */}
          <Grid item xs={12} md={7}>
            <Box sx={{ bgcolor: "#f5f7fa", p: { xs: 4, md: 6 } }}>
              <Grid container spacing={3}>
                {contractSteps.map((item, index) => (
                  <Grid item xs={6} sm={4} key={item.label}>
                    <Box sx={{ textAlign: "center" }}>
                      <Box
                        component="img"
                        src={item.icon}
                        alt={item.label}
                        sx={{
                          width: 70,
                          height: 70,
                          objectFit: "contain",
                          mb: 2,
                          mx: "auto",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1e3c72",
                          lineHeight: 1.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Contract Staffing
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                Contract staffing refers to the temporary tenure of IT staffing
                services you may need for special projects or seasonal overload
                work durations. We take the time to understand your
                organization’s needs and help you find dedicated and experienced
                resources.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Permanent Staffing  section */}
      <Box
        maxWidth="lg"
        sx={{
          mt: 8,
          position: "relative",
          zIndex: 1,
          // maxWidth: 1200,
          mx: "auto",
          // px: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={0} alignItems="stretch">
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Permanent Staffing
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 500,
                }}
              >
                Permanent staffing (or direct hire) refers to hiring IT staff
                long term, where employees are screened through a meticulous
                interview process. We utilize our experience on selecting the
                best available candidates with qualified technical skills and
                the ability to work under pressure.
              </Typography>
            </Box>
          </Grid>
          {/* left: Permanent icons */}
          <Grid item xs={12} md={5}>
            <Box sx={{ bgcolor: "#f5f7fa", p: { xs: 4, md: 6 } }}>
              <Grid container spacing={3}>
                {permanentSteps.map((item, index) => (
                  <Grid item xs={6} sm={4} key={item.label}>
                    <Box sx={{ textAlign: "center" }}>
                      <Box
                        component="img"
                        src={item.icon}
                        alt={item.label}
                        sx={{
                          width: 70,
                          height: 70,
                          objectFit: "contain",
                          mb: 2,
                          mx: "auto",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1e3c72",
                          lineHeight: 1.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* contract   section */}
      <Box
        maxWidth="lg"
        sx={{
          mt: 8,
          position: "relative",
          zIndex: 1,

          mx: "auto",
          backgroundImage: `url(${ContractImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container spacing={0} alignItems="stretch">
          <Grid item xs={12} md={4}></Grid>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #0143d1 0%, #1e3c72 100%)",
                color: "#ffffff",
                p: { xs: 2, md: 4 },
                borderRadius: 2,
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(1, 67, 209, 0.2)",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                }}
              >
                Contract to Hire
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                Contract to hire staffing can be the best of both worlds. In
                contract to hire, the technical employee remains an AlphaForce
                employee. AlphaForce pays the employee’s benefits, insurance etc
                while the client pays a predictable budgeted hourly rate. The
                customer can evaluate the consultant to make sure that they are
                a good fit and to assure that there is enough future work. When
                the client is ready, they can convert the employee to their
                payroll by paying a modest conversion fee to AlphaForce.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: 14,
                  opacity: 0.95,
                  fontWeight: 600,
                }}
              >
                Contact AlphaForce today for a discussion on the best talent
                solution for your needs.
              </Typography>
            </Box>
          </Grid>
          {/* left: Permanent icons */}
        </Grid>
      </Box>
    </Box>
  );
};

export default StaffingService;
